import BaseProxy from './Proxy';

export default class SubstoreAdministrationProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/administration', parameters);
  }

  orderAdministrationDialogData(subscriptionTemplateId, uniqueSubscriptionId) {
    return this.submit('get', `${this.endpoint}/stock/${subscriptionTemplateId}/${uniqueSubscriptionId}/selection`);
  }

  orderAdministrationSummaryDialogData(subscriptionTemplateId, uniqueSubscriptionId, requestedParameterValue) {
    return this.submit('post', `${this.endpoint}/stock/${subscriptionTemplateId}/${uniqueSubscriptionId}/summary`, { requestedParameterValue });
  }

  orderAdministrationConfirmationDialogData(subscriptionTemplateId, uniqueSubscriptionId) {
    return this.submit('get', `${this.endpoint}/stock/${subscriptionTemplateId}/${uniqueSubscriptionId}/confirmation`);
  }
}
